<template>
    <div>
        <van-nav-bar
                title="客户统计"
                left-text="返回"
                left-arrow
                @click-left="onClickLeft"
        />
        <van-cell-group>
            <van-cell title="每日客户统计" is-link url="#/mobile/money/index"/>
            <van-cell title="每月客户统计" is-link url="#/mobile/money/index"/>
            <van-cell title="客户管理" is-link url="#/mobile/money/index"/>
        </van-cell-group>
        <van-tabbar v-model="active">
            <van-tabbar-item icon="shop" :url="'#/mobile/statistic/income'">营收</van-tabbar-item>
            <van-tabbar-item :url="'#/mobile/statistic/flow'">
                <span>流量</span>
                <img slot="icon"
                     slot-scope="props"
                     :src="props.active ? icon.active : icon.normal"
                >
            </van-tabbar-item>
            <van-tabbar-item icon="contact" :url="'#/mobile/statistic/order'">交易</van-tabbar-item>
            <van-tabbar-item icon="contact" :url="'#/mobile/statistic/customer'">客户</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    import {TabbarItem,Tabbar,NavBar,CellGroup,Cell} from 'vant'
    export default {
        name: "customer",
        components:{
            [Tabbar.name]:Tabbar,
            [TabbarItem.name]:TabbarItem,
            [NavBar.name]:NavBar,
            [CellGroup.name]:CellGroup,
            [Cell.name]:Cell
        },
        data(){
            return {
                active:3,
                icon: {
                    normal: 'static/images/icon-applications-normal.png',
                    active: 'static/images/icon-applications-active.png'
                },
                memberUrl:this.loginDomain+'/jz/#/member/index',
            }
        },
        methods:{
            onClickLeft() {
                this.$router.push('/mobile')
            }
        }
    }
</script>

<style scoped>

</style>
